var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-editor',_vm._g(_vm._b({staticClass:"editor",attrs:{"customModules":_vm.customModules,"editorOptions":_vm.editorOptions,"useCustomImageHandler":true},on:{"image-added":_vm.readData}},'vue-editor',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }